import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext, UserContext, getClonedData } from 'commons-ui';

import useService from '../../utils/useService';
import { dehydrateBulkFormData } from '../../utils/formDataParser';
import { FORM_FIELD_KEYS } from '../../utils/bulkFormConfig';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const history = useHistory();
	const location = useLocation();

	const { requestCreatePartnerCoupon } = useService();

	const cloneCoupon = (clonedData: any) => {
		setShowLoader(true);
		const newData = {
			uid: user?.email,
			...clonedData
		};

		requestCreatePartnerCoupon(app.appName, newData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the bulk of a partner coupon'}`, {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Record cloned');
				history.goBack();

				setShowLoader(false);
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneCoupon(dehydrateBulkFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: getClonedData(_get(location, ['state', 'rowData']), FORM_FIELD_KEYS),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
